/**
 * LayoutPrefs — small context for global layout preferences (wide-mode toggle).
 * Persists to localStorage.
 */
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const LayoutPrefsContext = createContext({ wide: false, setWide: () => {} });

export function LayoutPrefsProvider({ children }) {
    const [wide, setWide] = useState(() => {
        try { return localStorage.getItem("ff-layout-wide") === "1"; } catch { return false; }
    });
    useEffect(() => {
        try { localStorage.setItem("ff-layout-wide", wide ? "1" : "0"); } catch { /* ignore */ }
    }, [wide]);
    // Memoise the context value so downstream consumers don't re-render when
    // an unrelated ancestor re-renders.
    const value = useMemo(() => ({ wide, setWide }), [wide]);
    return (
        <LayoutPrefsContext.Provider value={value}>
            {children}
        </LayoutPrefsContext.Provider>
    );
}

export function useLayoutPrefs() {
    return useContext(LayoutPrefsContext);
}
